import { ReferenceInput, required, SelectInput } from "react-admin";
import { useField } from "react-final-form";

const SchoolInput = () => {
  const routeArrayInput = useField("routeIds");
  const busScheduleInput = useField("busScheduleId");
  const busScheduleArrayInput = useField("busScheduleIds");
  const parentsInput = useField("parentIds");
  const driversInput = useField("driverIds");
  const busAssistantInput = useField("busAssistantIds");

  const reset = () => {
    busScheduleInput.input.onChange("");
    busScheduleArrayInput.input.onChange([]);
    routeArrayInput.input.onChange([]);
    parentsInput.input.onChange([]);
    driversInput.input.onChange([]);
    busAssistantInput.input.onChange([]);
  };

  return (
    <ReferenceInput
      label="Select School"
      source="schoolId"
      reference="schools"
      validate={required()}
      onChange={reset}
      perPage={9999}
      sort={{ field: "name", order: "ASC" }}
      // defaultValue={schoolIdSelected}
      // disabled
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
  );
};

export default SchoolInput;
